import HttpService from "./htttp.service";
import HttpDRService from "./httpdr.service";

let interceptorsRegistered = false;

export const setupAxiosInterceptors = (onUnauthenticated) => {
  if (interceptorsRegistered) {
    console.warn("⚠️ Axios interceptors already registered. Skipping.");
    return;
  }

  const onRequestSuccess = async (config) => {
    const token = localStorage.getItem("token");
    const fbSLAT = localStorage.getItem("fbSLAT");
    const activeWorkspaceId = localStorage.getItem("activeWorkspaceId");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (fbSLAT) {
      config.headers["X-Facebook-Authorization"] = `Bearer ${fbSLAT}`;
    }

    // console.log(`🚀 Request: ${config.method?.toUpperCase()} ${config.url} [Token: ${token ? 'YES' : 'NO'}]`);

    if (activeWorkspaceId) {
      config.headers["x-workspace-id"] = activeWorkspaceId;
    }

    return config;
  };

  const onRequestFail = (error) => Promise.reject(error);

  const onResponseSuccess = (response) => response;

  const onResponseFail = (error) => {
    const status = error.response?.status || error.status;
    const message = error.response?.data?.message?.toLowerCase() || "";
    const url = error.config?.url || "unknown";

    // 🛑 Avoid logging out on "Profile Limit Exceeded" (403) or "Permission Denied" (RBAC 403)
    const isLimitError = status === 403 && (message.includes("limit") || message.includes("upgrade"));
    const isPermissionError = status === 403 && (message.includes("permission denied") || message.includes("forbidden"));

    // 🛑 Skip logout redirect if already on a public auth page (e.g. /auth/live-demo in progress)
    const PUBLIC_AUTH_PATHS = ["/auth/login", "/auth/register", "/auth/live-demo", "/auth/demo", "/auth/forgot-password", "/auth/reset-password", "/auth/verify-email"];
    const isOnPublicAuthPage = PUBLIC_AUTH_PATHS.some(path => window.location.pathname.startsWith(path));

    if (!isOnPublicAuthPage && ((status === 403 && !isLimitError && !isPermissionError) || status === 401)) {
      console.error(`🚨 Unauthenticated access detected (${status}) on URL: ${url}. Message: ${message}`);
      onUnauthenticated();
    }

    return Promise.reject(error);
  };

  // ✅ Register interceptors for both services
  HttpService.addRequestInterceptor(onRequestSuccess, onRequestFail);
  HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail);

  HttpDRService.addRequestInterceptor(onRequestSuccess, onRequestFail);
  HttpDRService.addResponseInterceptor(onResponseSuccess, onResponseFail);

  interceptorsRegistered = true;
  console.log("✅ Axios interceptors initialized successfully with telemetry.");
};

